<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .warning {
    display: flex;
    color: colors.get(systemError_100);
    background-color: colors.get(systemError_10);
    padding: utils.in_rem(8px);
    border-radius: 6px;
    text-align: left;
    gap: utils.in_rem(8px);
  }

  .warning-title {
    font-weight: 600;
    margin-bottom: utils.in_rem(4px);
  }

  .warning-list {
    margin: 0;
    padding-left: utils.in_rem(16px);

    li {
      margin-bottom: utils.in_rem(2px);

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import { hasAnyLicensesAvailable, hasSignInLicense } from "../stores";

  let warningList = $derived.by(() => {
    const ret = [];
    if (!$hasSignInLicense) {
      ret.push(
        "You won't be able to sign in unless you assign yourself licenses now. Licenses marked with an * are add-ons and don't provide access on their own."
      );
    }
    if (!$hasAnyLicensesAvailable) {
      ret.push(
        "No licenses are currently available. Contact your admin to add more licenses."
      );
    }
    return ret;
  });
</script>

{#if warningList.length === 1}
  <div class="warning">
    <Icon class="fas fa-exclamation-circle" />
    <div>{warningList[0]}</div>
  </div>
{:else if warningList.length > 1}
  <div class="warning">
    <Icon class="fas fa-exclamation-circle" />
    <div>
      <div class="warning-title">Warning</div>
      <ul class="warning-list">
        {#each warningList as warning}
          <li>{warning}</li>
        {/each}
      </ul>
    </div>
  </div>
{/if}
